import { CheckoutGuaranteeWarningSidePanelModule } from './panels/checkout-guarantee-warning-aside-panel/checkout-guarantee-warning-aside-panel.module';
import { CheckoutTermAcceptSidePanelModule } from './panels/checkout-term-accept-aside-panel/checkout-term-accept-aside-panel.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

// Modules
import { CheckoutPanelModule } from './panels/checkout/checkout-panel.module';
import { AnalysisPreviewDialogModule } from './panels/analysis-preview-dialog/analysis-preview-dialog.module';
import { SuccessAsidePanelModule } from './panels/success-aside-panel/success-aside-panel.module';
import { GuaranteeAsidePanelModule } from './panels/guarantee-aside-panel/guarantee-aside-panel.module'
import { TradingnoteAsidePanelModule } from './panels/tradingnote-aside-panel/tradingnote-aside-panel.module';

@NgModule({
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    imports: [
        CheckoutPanelModule,
        AnalysisPreviewDialogModule,
        CommonModule,
        SuccessAsidePanelModule,
        CheckoutTermAcceptSidePanelModule,
        CheckoutGuaranteeWarningSidePanelModule,
        GuaranteeAsidePanelModule,
        TradingnoteAsidePanelModule,
    ],
    exports: [],
})

export class SharedModule {}
